module.exports = function getResource(label, vars = []) {
    let resources = {
        orderText: 'Commande',
        dateLocationText: 'Date et lieu'
    };

    return resources[label];
};
